<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-content class="backgroundcolordark">
    <v-layout>
      <v-img src="static/edologic_examenis.png" min-height="594px">
        <v-layout fill-height>
          <v-container>
            <v-layout pa-2 row wrap class="lightbox white--text hidden-xs-only">
              <v-flex xs12 sm12 md12 lg12 text-xs-center>
                <v-card tile flat color="black" dark>
                  <div class="display-3 font-weight-bold">
                    examenis.
                  </div>
                </v-card>
                <v-card tile flat color="black" dark>
                  <div class="headline font-weight-light white--text mt-3">
                    die intelligente Softwarelösung <br> für moderne Prüfungen und Umfragen
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout pa-2 row wrap class="lightbox white--text hidden-sm-and-up">
              <v-flex xs12 sm12 md12 lg12 text-xs-center>
                <v-card tile flat color="black" dark>
                <div class="display-1 font-weight-bold">
                  examenis.
                </div>
                </v-card>
                <v-card tile flat color="black" dark>
                <div class="headline font-weight-light white--text mt-3">
                  die intelligente Softwarelösung <br> für moderne Prüfungen und Umfragen
                </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
      </v-img>
    </v-layout>
    <v-layout>
      <v-container>
        <v-layout row class="ma-5">
          <v-flex xs12>
            <v-card dark tile flat color="transparent" class="text-xs-center">
              <v-card-text class="display-3 font-weight-bold">erstellen, durchführen, analysieren</v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-container fluid grid-list-md>
        <v-layout row wrap justify-center>
          <v-flex d-flex xs12 sm10 md9>
            <v-card dark color="transparent" flat>
              <v-card-text class="lineheight">
                Es war noch nie so einfach und effizient Prüfungen und Umfragen zu erstellen und auszuwerten. examenis
                bietet Ihnen die Möglichkeit online über den Browser oder offline auf einem lokalen Rechner zu arbeiten.
                <br><br>
                Selbst papierbasierte Ausführungen können, dank Scanner-Schnittstelle erfasst und analysiert werden.
                examenis offeriert Ihnen ein breites Spektrum an Fähigkeiten Fragen zu implementieren. Single- und
                Multiple Choice-Fragen bilden im System die Basis von Zuordnungs-, Umordnungs- und Vergleichsaufgaben.
                Im Bereich freier Beantwortung sind Ergänzungs-, Begriffs- und Textaufagben möglich.
                <br><br>
                Die ökonomische Filterfunktion hilft Ihnen dabei Ihre archivierten und aktuellen Dokumente schneller und
                einfacher zu finden.
                <br><br>
                Durch examenis haben Sie keinerlei Datenverluste mehr, denn die gesamten Daten werden auf
                digitaler Ebene archiviert und sind zu jeder Zeit abrufbar. Die bedienerfreundliche Oberfläche
                erleichtert Ihnen das Arbeiten und ist somit ein weiterer Vorteil in der Erstellung und Auswertung von
                Prüfungsaufgaben.
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        </v-container>
      </v-container>
    </v-layout>

    <v-card flat color="transparent" class="mb-5">
      <v-layout row algin-center fill-height>
        <v-container>
          <v-layout row class="ma-5">
            <v-flex xs12>
              <v-card dark tile flat color="transparent" class="text-xs-center mb-5">
                <v-card-text class="display-3 font-weight-bold">„Es war noch nie so einfach“</v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout justify-center class="hidden-xs-only">
            <v-flex xs12>
              <v-card dark tile flat color="transparent" class="text-xs-center mb-5">
                <v-timeline dark>
                  <v-timeline-item
                    v-for="(item, i) in titles"
                    :key="i"
                    :color="item.color"
                    large
                    class="my-5"
                  >
                    <template v-slot:opposite>
        <span
          :class="`display-4 font-weight-light ${item.color}--text`"
          v-text="item.title"
        ></span>
                    </template>
                    <div class="py-5 my-5">
                      <h2 :class="`display-1 text-xs-left font-weight-bold mb-3 ${item.color}--text`">
                        {{item.headline}}</h2>
                      <div class="lineheight text-xs-left" v-html="item.text">
                      </div>
                    </div>
                  </v-timeline-item>
                </v-timeline>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout justify-center class="hidden-sm-and-up">
            <v-container>
            <v-flex xs12>
              <v-card dark tile flat color="transparent" class="text-xs-center mb-5">
                <v-timeline dark>
                  <v-timeline-item
                    v-for="(item, i) in titles"
                    :key="i"
                    :color="item.color"
                    small
                    class="my-5"
                  >
                    <template v-slot:opposite>
        <span
          :class="`display-3 font-weight-light ${item.color}--text`"
          v-text="item.title"
        ></span>
                    </template>
                    <div class="py-5 my-5">
                      <h2 :class="`title text-xs-left font-weight-bold mb-3 ${item.color}--text`">
                        {{item.headline}}</h2>
                      <div class="lineheightsmall text-xs-left" v-html="item.text">
                      </div>
                    </div>
                  </v-timeline-item>
                </v-timeline>
              </v-card>
            </v-flex>
            </v-container>
          </v-layout>
        </v-container>
      </v-layout>
    </v-card>
    <v-layout row wrap>
      <v-flex>
      <v-img src="static/examenis_screen.png" class="mb-5" min-height="594px">
        <v-layout wrap>
          <v-layout class="hidden-xs-only">
          <v-container>
            <v-flex xs12>
              <v-card dark tile flat color="transparent" class="text-xs-center mb-5">
                <v-card-text class="display-1 font-weight-light">Starten Sie jetzt in das moderne Prüfungs- und Umfrage-Zeitalter –<br> es war noch nie so einfach.</v-card-text>
              </v-card>
            </v-flex>
          </v-container>
          </v-layout>
        </v-layout>
        <v-layout pa-2 row wrap class="lightbox white--text hidden-sm-and-up">
          <v-flex xs12 sm12 md12 lg12 text-xs-center>
            <v-card dark tile flat color="transparent" class="text-xs-center mb-5">
              <v-card-text class="title font-weight-light">Starten Sie jetzt in das moderne <br> Prüfungs- und Umfrage-Zeitalter – <br>es war noch nie so einfach.</v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-img>
      </v-flex>
    </v-layout>
    <v-layout row class="ma-5">
      <v-flex xs12 class="ma-5">
        <v-card dark tile flat color="transparent" class="text-xs-center mb-5">
                <v-card-text class="display-1 font-weight-light">
                  <a href="mailto:info@edologic.de" style="color: white; text-decoration: none">Mehr Informationen per E-Mail erhalten</a>
                </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
  // import Vue from 'vue'

  export default {
    metaInfo: {
      title: 'edologic GmbH - Geniale Projekte beginnen hier',
      // override the parent template and just use the above title only
      titleTemplate: null,
      meta: [
        {
          name: 'description',
          content: 'Innovative Softwarelösungen und atemberaubendes Designs von der edologic – Ihrem Partner für professionelle Softwareentwicklung mit bemerkenswertem Design'
        }]
    },
    data () {
      return {
        dialog: false,
        dialog2: false,
        dialog3: false,
        dialog4: false,
        titles: [
          {
            color: 'cyan',
            title: '1',
            headline: 'Fragen erstellen / Editor',
            text: '<p class="p1">&bull; Verwendung geschlossener Fragetypen</p><p class="p1">&bull; Verwendung offener Fragen</p><p class="p1">&bull; Verwendung von Grafiken und <br />Multimedia in Fragen</p><p class="p1">&bull; Anzeige von Ver&auml;nderungsdaten der<br />Fragen (letzte &Auml;nderung/Verwendung, <br />H&auml;ufigkeit Verwendung)</p><p class="p1">&bull; Versionierung der Fragen</p><p class="p1">&bull; Erfassung von Kommentaren zu Fragen</p><p class="p1">&bull; Einordnung der Fragen in Teilgebiete und <br />Fachgebiete (Mehrfachfiltersystem)</p><p class="p1">&bull; Kopierfunktion f&uuml;r Fragen</p><p class="p1">&bull; Individuelle, freie Platzierung / Anordnung <br />von Frageelementen (Text, Absatz, <br />Ausrichtung)</p><p class="p1">&bull; Zeichen- und Absatzformatierung von <br />Frageelementen</p><p class="p1">&bull; Verwendung von eigenen <br />HTML Elementen / Code</p><p class="p1">&bull; Individuelle, freie Gestaltung / <br />Design der Fragen</p><p class="p1">&bull; Umfangreiche Bepunktungssysteme <br />pro Frage</p><p class="p1">&bull; Zufallsverteilte Reihenfolge der<br />Antwortalternativen bei geschlossenen <br />Fragen</p><p class="p1">&bull; Verwendung von LaTex-Formeln <br />und &ndash;ausdr&uuml;cken</p>'
          },
          {
            color: 'green',
            title: '2',
            headline: 'Test / Klausur erstellen',
            text: '<p class="p1">&bull; Anzeige von Ver&auml;nderungsdaten der <br />Tests (letzte &Auml;nderung/Verwendung, <br />H&auml;ufigkeit Verwendung)</p><p class="p1">&bull; Voransicht / Vorschau des Tests / <br />der Testfragen</p><p class="p1">&bull; Einfache Umordnung der Fragen <br />innerhalb eines Tests</p><p class="p1">&bull; Kopierfunktion f&uuml;r Tests</p><p class="p1">&bull; Suchfunktion von Tests nach<br />verschiedenen Kriterien (Autor, ID, Fach,<br />Teilgebiet, Schlagwort)</p><p class="p1">&bull; Einordnung der Tests in Teilgebiete und <br />Fachgebiete (Mehrfachfiltersystem)</p><p class="p1">&bull; Optionale Zeitvorgaben f&uuml;r die <br />Durchf&uuml;hrung der Tests (online)</p><p class="p1">&bull; Optionale Mehrfachanmeldung an einem <br />Test je Teilnehmer (online)</p><p class="p1">&bull; Vier-Augen-Prinzip / Freigabefunktion f&uuml;r <br />erstellte Fragen / Pr&uuml;fungen</p><p class="p1">&bull; Zufallsgesteuertes Mischen der <br />Frageanordnung</p><p class="p1">&bull; Fixieren der Positionen von Klausurfragen <br />beim Mischen</p><p class="p1">&bull; Integrierbarkeit von zus&auml;tzlichen <br />Pr&uuml;fungspunkten zur Gesamtnote</p>'
          },
          {
            color: 'pink',
            title: '3',
            headline: 'Prüfung durchführen',
            text: '<p class="p1">&bull; Optionale Nachbearbeitung von <br />Teilnehmern</p><p class="p1">&bull; Importieren von Teilnehmern aus <br />bestehenden Datenbanken</p><p class="p1">&bull; Personifizierte Testdurchf&uuml;hrung <br />PIN/TAN (online)</p><p class="p1">&bull; Bereitstellung der Teilnehmerzug&auml;nge <br />per Ausdruck (online)</p><p class="p1">&bull; Detaillierte Teilnehmerdaten online <br />einsehbar</p><p class="p1">&bull; Individuelles Sperren einzelner Teilnehmer <br />(online)</p><p class="p1">&bull; Gemischte Pr&uuml;fungsform m&ouml;glich <br />(papier- und EDV-gest&uuml;tzt)</p><p class="p1">&bull; Automatisierte Identifizierung der <br />Antwortb&ouml;gen durch Barcode</p><p class="p1">&bull; Automatisierte Identifizierung der <br />Teilnehmer durch Kenncode</p><p class="p1">&bull; Getrennte Erstellung von <br />Lernfortschrittskontrollen <br />(&Uuml;bungsklausuren)</p><p class="p1">&bull; Lokale Durchf&uuml;hrung von <br />&Uuml;bungsklausuren</p><p class="p1">&bull; Multilingualit&auml;t bei Durchf&uuml;hrung der <br />Pr&uuml;fungen</p><p class="p1">&bull; Erweiterte Personendaten f&uuml;r Teilnehmer <br />verwalten</p>'
          },
          {
            color: 'amber',
            title: '4',
            headline: 'Datenauswertung',
            text: '<p class="p1">&bull; Test jederzeit auswertbar</p><p class="p1">&bull; Automatisches Einlesen von <br />papierbasierten Antwortb&ouml;gen per <br />Dokumentenscanner</p><p class="p1">&middot;&bull; Sichere Archivierung von Pr&uuml;fungen</p><p class="p1">&bull; Grafische Ergebnisdarstellung</p><p class="p1">&bull; &Uuml;bersicht der einzelnen <br />Antwortergebnisse pro Frage</p><p class="p1">&bull; Angabe der Durchschnittsnoten / <br />der Durchschnittspunktzahl</p><p class="p1">&bull; Berechnung wichtiger statistischer <br />Kennwerte (Schwierigkeit, Trennsch&auml;rfe)</p><p class="p1">&bull; Heben- und Senkenfunktionalit&auml;t <br />der Ergebnisse</p><p class="p1">&bull; Individuelle Eingabe und Bearbeitung <br />des Notenschl&uuml;ssels</p><p class="p1">&bull; Automatischer Export der Daten in <br />andere Datenformate</p><p class="p1">&bull; Evaluationsergebnisse von <br />Pr&uuml;fungen einbindbar</p>'
          },
          {
            color: 'orange',
            title: '5',
            headline: 'Verwaltung / Integration',
            text: '<p class="p1">&bull; Benutzergruppenverwaltung</p><p class="p1">&bull; Internes Kommunikationssystem <br />(bei Fehlern, Meldungen, Hinweise)</p><p class="p1">&bull; Keine lokale Softwareinstallation <br />notwendig</p><p class="p1">&bull; Nutzung &uuml;ber herk&ouml;mmliche Webbrowser</p><p class="p1">&bull; Assistent f&uuml;r alternative Bedienung <br />des Systems</p><p class="p1">&bull; Anbindung an bestehende <br />Authentifizierungssysteme m&ouml;glich</p><p class="p1">&bull; Automatisches zeitgesteuertes L&ouml;schen <br />von alten Teilnehmer-Antworten</p>'
          }
        ]
      }
    },
    methods: {
      routeToGlobal (url) {
        window.open(url, '_new')
      },
      routeTo (url) {
        this.$router.push(url)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/examenisnew.vue